module.exports = __webpack_public_path__ + "img/GNIPU.2ee93670.png";